export default function(o, marker){

  var lang = o.store('lang')

  var antiArchiveLabel = o.util.getTranslation(o, 'antiArchive')

  var tagDiv =
    $('<div>')
    .css({
      display: 'inline-block',
      margin: '0.3rem',
      color: o.colors.red,
    })
    .html(marker[lang])

  var home = function(){
    history.pushState({}, '', '/')
    o.render(o)
  }

  var setTag = function(marker){
    tagDiv.html(marker[lang])
  }

  var div =
    $('<div>')
    .css({
      textAlign: 'center',
      whiteSpace: 'nowrap',
      overflowY: 'auto',
      '-webkit-overflow-scrolling': 'touch',
      fontSize: o.fontSizeDef.s,
      padding: "0.8rem",
    })
    .append([
      o.component.button(o, 'open memory box', home),
    ])

  div.append([
    o.component.spacer(o),
    o.component.button(o, antiArchiveLabel),
    o.component.spacer(o),
    tagDiv,
  ])

  div.setTag = setTag

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/antiArchiveTag/header/header.js